import React from "react";

type ComponentProps = {};

const Page: React.FC<ComponentProps> = () => {
  return <>Статистика по объектам</>;
};

export default Page;
